import axios from 'axios'
import { LocalStorageService } from '../services'

class PersonTypeService {
  constructor(apiUrl) {
    this.apiUrl = apiUrl
  }
  url = process.env.REACT_APP_MIFIRMA_API
  localStorageService = new LocalStorageService()

   /**
  * @author Lucia Alvarado
  * @description Get personType By personTypeId
  * @date 03-10-2021
  * @param {String} token
  * @param {Object} taxData
  * @returns {Object}
  * @memberof PersonTypeService
  */

  async getPersonTypeById (id, token) {
    let response = await axios.get(`${this.apiUrl}/person-type?id=${id}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
    return response.data.data
  }
}

export { PersonTypeService as default }
